import { Button } from '@cue/atoms';
import { Menu, MenuItemData } from '@cue/molecules';
import { useNavMenu } from '@project/hooks/use-nav-menu';
import { useMemo } from 'react';

export interface FooterMenuProps {
  slug: string;
}
export const SocialMenu = ({ slug }: FooterMenuProps) => {
  const { menuItems } = useNavMenu(slug);

  const items = useMemo(
    () =>
      menuItems.map((item) => ({
        ...item,
        render: ({ link, icon }: MenuItemData) => (
          <a href={link || ''} target="_blank" rel="noreferrer">
            <Button styling="socialMenuItem" icon={icon || undefined} />
          </a>
        ),
      })),
    [menuItems],
  );

  return <Menu items={items} />;
};
